/**
 * VITE_API_URL is the full versioned base (`…/api/v1`), which the shared axios
 * client uses as-is. The few fetch() call sites that build URLs by hand need
 * the origin and add `/api/v1/…` themselves; deriving it here keeps the two
 * conventions from drifting into `/api/v1/api/v1/…`.
 */
export function getApiBase(): string {
  const base = import.meta.env.VITE_API_URL || "http://localhost:8000/api/v1";
  return base.replace(/\/+$/, "").replace(/\/api\/v1$/, "");
}
